module.exports = function (index, column, options) {
  var html = '';  
  
  if(index%column == 0){
    html += '<!--[if mso | IE]>' +
              '<tr>'+
            '<![endif]-->';
  }

  var paddingLeft = index%column == 0 ? 10 : 0; 

  html += '<!--[if mso | IE]>' +
            '<td style="vertical-align:top;width: 14.37rem;">'+
          '<![endif]-->';
            
  html += '<div class="mj-column-per-50 outlook-group-fix" style="vertical-align:top;display:inline-block;direction:ltr;font-size: 0.813rem;text-align:left;width:100%; padding-bottom: 0.62rem; max-width: 17.188rem;margin-right: 0.8rem">'
            + options.fn(this) + '</div>';

  html += '<!--[if mso | IE]>'+
            '</td>' +
          '<![endif]-->'            

  if(index%column != 0){
    html += '<!--[if mso | IE]>'+
              '</tr>'+
            '<![endif]-->';
  }

  return html;
};